import { ModuleNode } from "../types";

export const MLObservabilityModule: ModuleNode = {
  key: "ml-observability",
  title: "ML Observability",
  pages: [
    {
      key: "summary",
      title: "Summary",
      route: "/machineLearning/dashboard",
      items: [
        { key: "model-details", label: "Models Details", tags: ["model","ml","summary"] },
      ],
    },
  ],
};
